import { Component, ViewChild } from "@angular/core";

import {
    ApexAxisChartSeries,
    ApexTitleSubtitle,
    ApexChart,
    ApexXAxis,
    ChartComponent
} from "ng-apexcharts";

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    title: ApexTitleSubtitle;
    xaxis: ApexXAxis;
    colors: any;
};

@Component({
    selector: 'app-basic-radar-chart',
    templateUrl: './basic-radar-chart.component.html',
    styleUrls: ['./basic-radar-chart.component.scss']
})
export class BasicRadarChartComponent {

    @ViewChild("chart") chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    constructor() {
        this.chartOptions = {
            series: [
                {
                    name: "Tagus",
                    data: [80, 50, 30, 40, 100, 20]
                }
            ],
            chart: {
                height: 350,
                type: "radar",
                toolbar: {
                    show: true
                }
            },
            title: {
                text: "Basic Radar Chart"
            },
            xaxis: {
                categories: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho"]
            },
            colors: ["#757fef"]
        };
    }

}